import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import NewApp from "./NewApp.jsx";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { locale, loadMessages } from 'devextreme/localization';
import plMessages from 'devextreme/localization/messages/pl';

loadMessages(plMessages);
locale('pl');

const appVersion = localStorage.getItem("APP_VERSION") || "1.0.0";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["pl", "en", "de"],

    fallbackLng: "pl",

    detection: {
      order: ["path", "cookie", "htmlTag", "localStorage", "subdomain"],
      caches: ["cookie"],
    },

    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
      queryStringParams: { v: appVersion },
    },
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 
    <NewApp />
  
);
